import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../../common/models/single-response.model';


import { GrantActionTypes , GrantActions, LoadGrantsSuccess} from '../actions/grant.actions';
import { SummaryGrantModel } from '../../models/summary-grant.model';


export interface GrantState {
  items: SummaryGrantModel[];
  total: number;
  res: PaginableResponseModel<SummaryGrantModel>;
  selected: SingleResponseModel<SummaryGrantModel> | null;
  loading: boolean;
  error: any
}


export const initalState: GrantState = {
  items: [],
  total: 0,
  res: null,
  selected: null,
  loading: false,
  error: null
};

export function GrantReducer(
  state = initalState,
  action: GrantActions
): GrantState {

  switch (action.type) {
    case GrantActionTypes.LoadGrants:
      return { ...state, loading: true, error: null };

    case GrantActionTypes.LoadGrantsSuccess:
      const { items, total } = (action as LoadGrantsSuccess).payload;
           return {
             ...state,
             loading: false,
             error: null,
             items: items,
             total: total,
           };
    case GrantActionTypes.LoadGrantsFailure:
      return{ ...state, loading: false, error: action.payload.error };


    case GrantActionTypes.LoadGrantSuccess:
      return {
        ...state,
        selected: action.payload
      };

    default:
      return state;
  }
}
